import { format } from 'date-fns';

/**
 * Formats a date into the client notes timestamp format: "THURSDAY | 04/21/25 | 1:00PM"
 * @param date - Date object, date string, or undefined (uses current date)
 * @returns Formatted timestamp string
 */
export function formatNoteTimestamp(date?: Date | string): string {
  const dateObj = date ? new Date(date) : new Date();

  const dayName = format(dateObj, 'EEEE').toUpperCase();
  const formattedDate = format(dateObj, 'MM/dd/yy');
  const time = format(dateObj, 'h:mma').toUpperCase();

  return `${dayName} | ${formattedDate} | ${time}`;
}
